<ngx-ui-loader></ngx-ui-loader>
<div class="container-fluid" style="padding: 0 1.8rem 1.8rem">
    <h5>Object and Intrusion Detection Report</h5>

        <mat-card>
            <mat-card-content>
                <div class="row">
                    <div class="col-md-3">
                        <ng-select [items]="transformerList" bindLabel="transformerDetail" placeholder="Select Transformer" [(ngModel)]="selectedTransformer" [clearable]="false" (change)="transformerSelection(selectedTransformer)">
                        </ng-select>
                    </div>
                    <div class="col-md-3">
                        <ng-select [items]="durationList" bindLabel="name" placeholder="Duration"
                            [(ngModel)]="selectedDuration"
                            (change)="durationSelectionAlert(selectedDuration)" [clearable]="false">
                        </ng-select>
                    </div>
                    <div *ngIf="showDateRange" style="padding-top: 20px" [ngClass]="{'col-md-2' : showDateRange == true}">
                        <input [owlDateTime]="dt1" [selectMode]="'range'" [owlDateTimeTrigger]="dt1"
                            placeholder="Select Date Range" (dateTimeChange)="changeDateRange($event)">
                        <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>

    
    <!--<div class="col-md-12">
        <table mat-table matTableExporter [dataSource]="dataSource" #exporter="matTableExporter" matSort class="example-container mat-elevation-z8" style=" width: 100%;">
            <ng-container *ngFor="let col of getColumn()">
            <ng-container [matColumnDef]="col">
                <th mat-header-cell *matHeaderCellDef>{{ col }}</th>
                <td mat-cell *matCellDef="let element">{{ dataSource[col] }}</td>
            </ng-container>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="getColumns();"></tr>
            <tr mat-row *matRowDef="let row; col: getColumns();"></tr>
        </table>
    </div>-->

    <div class="row col-md-12" style="margin-top: 2%;">
        <div class="col-md-12">
          <div >
            <table mat-table matTableExporter [dataSource]="dataSource" #exporter="matTableExporter" matSort class="example-container mat-elevation-z8" style=" width: 100%;" >
                <div *ngFor="let col of heading">

              <ng-container  *ngIf="isDataSource" [matColumnDef]="col">
                <div *ngIf="col" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style=" background-color:wheat; color: black;"> {{col}} </th>
                </div>
                  <div *ngIf="col">
                    <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="col === 'objectdetected' || col === 'intrusiondetected'">
                            {{ element[col]==1 ? 'Yes' : 'No' }}
                        </ng-container>
                        <ng-container *ngIf="col !== 'objectdetected' && col !== 'intrusiondetected'">
                            {{ element[col] }}
                          </ng-container> 
                    </td>
                  </div>
                  
                </ng-container>
              </div>
                <tr mat-header-row *matHeaderRowDef="heading"></tr>
                <tr mat-row *matRowDef="let row; columns: heading;"></tr>
              </table>
              <mat-paginator #paginator [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons></mat-paginator>
          </div>    
        </div>
    </div>

    <div class="row col-md-12" *ngIf="!isDataSource">
        <h2>There is no data for the selection</h2>
    </div>

</div>